import * as tslib_1 from "tslib";
import { SiteStore } from './site-store/siteStore';
import { configureWorkerRaven, createControllerRaven, createFakeRaven, withErrorReporting, withViewerScriptErrorReporting, viewerScriptErrorReporter, } from './errorReporter';
import { sentryConfPerController } from './sentryConf';
function emptyCtrl() {
    return {
        pageReady: function () {
            //
        },
        exports: function () { return ({}); },
    };
}
var defaultOptions = {
    useWorkerRaven: true,
};
export function createViewerScript(controllerFactories, options) {
    if (options === void 0) { options = {}; }
    var context = {};
    options = tslib_1.__assign({}, defaultOptions, options);
    return withViewerScriptErrorReporting({
        initAppForPage: function (initParams, apis, namespaces, platformServices) {
            var userMonitoringContext = { id: initParams.instanceId, url: namespaces.location.baseUrl };
            context.siteStore = new SiteStore(initParams, apis, namespaces, platformServices);
            if (options.useWorkerRaven) {
                configureWorkerRaven(platformServices, userMonitoringContext);
                context.createMonitoring = createControllerRaven(platformServices, userMonitoringContext, context.siteStore);
            }
            else {
                context.createMonitoring = createFakeRaven();
            }
            return context.siteStore.loadClientConfig().catch(viewerScriptErrorReporter);
        },
        createControllers: function (controllerConfigs, controllerInstances) {
            return controllerConfigs.map(function (_a) {
                var type = _a.type, config = _a.config, compId = _a.compId, setProps = _a.setProps, platformAPIs = _a.platformAPIs, warmupData = _a.warmupData;
                var ctrlFactory;
                if (context.siteStore.experiments.enabled('specs.stores.SeparateViewerScript') &&
                    controllerInstances &&
                    controllerInstances[type]) {
                    ctrlFactory = {
                        factory: controllerInstances[type][Object.keys(controllerInstances[type])[0]],
                        sentryDSN: sentryConfPerController[type],
                    };
                }
                else {
                    ctrlFactory = controllerFactories[type];
                }
                var ctrl;
                if (ctrlFactory) {
                    var reportError_1 = context.createMonitoring(ctrlFactory.sentryDSN);
                    var setPropsWithErrorsReporting = function (props) { return setProps(withErrorReporting(reportError_1)(props)); };
                    ctrl = ctrlFactory.factory({
                        config: config,
                        compId: compId,
                        context: context,
                        setProps: setPropsWithErrorsReporting,
                        platformAPIs: platformAPIs,
                        reportError: reportError_1,
                        type: type,
                        warmupData: warmupData,
                    });
                    ctrl = withErrorReporting(reportError_1)(ctrl);
                }
                else {
                    ctrl = emptyCtrl();
                }
                return Promise.resolve(ctrl);
            });
        },
    });
}
//# sourceMappingURL=createViewerScript.js.map